import { z } from 'zod'

// a per-account portfolio drawdown watch: fires once when the account's total unrealized
// return % drops to (≤) the armed target, then disarms (FIRED) until the user re-arms.
export const DRAWDOWN_WATCH_STATUSES = ['ARMED', 'FIRED'] as const
export const drawdownWatchStatusSchema = z.enum(DRAWDOWN_WATCH_STATUSES)
export type DrawdownWatchStatus = z.infer<typeof drawdownWatchStatusSchema>

// arm / re-arm request: the target unrealized-return % (a drop threshold, may be negative).
// must be strictly below the account's current unrealized return % at arm time (drops-only) —
// enforced server-side.
export const armDrawdownWatchSchema = z.object({
  targetPercent: z.number().finite(),
})
export type ArmDrawdownWatchDto = z.infer<typeof armDrawdownWatchSchema>

// the persisted watch. `firedAt`/`firedValue` are set only once the watch has fired.
export const drawdownWatchSchema = z.object({
  status: drawdownWatchStatusSchema,
  targetPercent: z.number(),
  armedAt: z.string(),
  firedAt: z.string().nullable(),
  firedValue: z.number().nullable(),
})
export type DrawdownWatchDto = z.infer<typeof drawdownWatchSchema>

// GET/POST response: the current watch (null when the account has never been armed).
export const drawdownWatchStatusResponseSchema = z.object({
  watch: drawdownWatchSchema.nullable(),
})
export type DrawdownWatchStatusResponseDto = z.infer<typeof drawdownWatchStatusResponseSchema>
